import { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";
import { isStandalone, detectPlatform, InstallGuideModal } from "@/components/InstallButton";

const DISMISS_KEY = "yaya_install_banner_dismissed";

const isMobile = () => detectPlatform() !== "desktop";

export function InstallBanner() {
  const [visible, setVisible] = useState(false);
  const [platform, setPlatform] = useState("desktop");
  const [guideOpen, setGuideOpen] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (localStorage.getItem(DISMISS_KEY)) return;
    if (!isMobile()) return;
    setPlatform(detectPlatform());
    const t = setTimeout(() => setVisible(true), 2500);
    const onInstalled = () => setVisible(false);
    window.addEventListener("pwa-installed", onInstalled);
    return () => {
      clearTimeout(t);
      window.removeEventListener("pwa-installed", onInstalled);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const install = async () => {
    const dp = window.__deferredInstallPrompt;
    if (dp) {
      try {
        dp.prompt();
        await dp.userChoice;
        window.__deferredInstallPrompt = null;
        setVisible(false);
        return;
      } catch {
        window.__deferredInstallPrompt = null;
      }
    }
    setGuideOpen(true);
  };

  if (!visible) return null;

  return (
    <>
      <div
        data-testid="install-banner"
        className="fixed inset-x-3 bottom-3 z-[60] animate-[slideUp_0.35s_ease-out] rounded-2xl border border-terracotta/20 bg-white/95 p-3 shadow-xl backdrop-blur-md sm:hidden"
        style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      >
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-terracotta text-white">
            <DeviceMobile weight="fill" className="h-6 w-6" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-extrabold leading-tight text-forest">
              Ajoutez YAYA EXAM à votre écran d'accueil
            </p>
            <p className="mt-0.5 text-xs text-forest/70">Accès rapide, hors-ligne et sans navigateur.</p>
          </div>
          <button
            onClick={dismiss}
            data-testid="install-banner-close"
            aria-label="Fermer"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-forest/50 transition hover:bg-forest/5 hover:text-forest"
          >
            <X weight="bold" className="h-4 w-4" />
          </button>
        </div>
        <button
          onClick={install}
          data-testid="install-banner-cta"
          className="mt-2.5 w-full rounded-xl bg-terracotta py-2.5 text-sm font-bold text-white transition hover:bg-[#E03E00]"
        >
          Installer maintenant
        </button>
      </div>
      <InstallGuideModal open={guideOpen} onOpenChange={setGuideOpen} platform={platform} />
    </>
  );
}
